/**
 * @memberof system-metadata
 * @enum {string}
 * @property {string } OFFICIAL
 * @property {string} PROJECTION
 * @property {string} HISTORICAL
 * @description
 * The TimeContextType provides a semantic understanding to the currency of the data.
 *
 * {TimeContextType.OFFICIAL} represents the most recent measured data from a given source.
 * {TimeContextType.PROJECTION} represents the a future prediction of this data.
 * {TimeContextType.HISTORICAL} represents the a past measurement (which may include geographical
 *   harmonization) of this data.
 */
var TimeContextType;
(function (TimeContextType) {
    TimeContextType["OFFICIAL"] = "official";
    TimeContextType["CURRENT"] = "current";
    TimeContextType["PROJECTION"] = "projection";
    TimeContextType["HISTORICAL"] = "historical";
})(TimeContextType || (TimeContextType = {}));
TimeContextType[TimeContextType.OFFICIAL] = TimeContextType.OFFICIAL;
TimeContextType[TimeContextType.CURRENT] = TimeContextType.CURRENT;
TimeContextType[TimeContextType.PROJECTION] = TimeContextType.PROJECTION;
TimeContextType[TimeContextType.HISTORICAL] = TimeContextType.HISTORICAL;
export default TimeContextType;
